import React, { useMemo } from "react";

import classNames from "classnames/bind";

import { Item } from "./Item";

import styles from "./Flex.module.scss";

import type { PropsWithChildren } from "react";

import type { FlexContainerProps } from "./types";

const cx = classNames.bind(styles);

export const Container = ({
  direction = "row",
  gap = "medium",
  children,
  variant = "flex",
}: PropsWithChildren<FlexContainerProps>) => {
  const childElements = useMemo(() => {
    if (Array.isArray(children)) {
      return children.map((child, index) => {
        if (child.type.name === Item.name) {
          return child;
        }

        return <Item key={`flex-item-${index}`}>{child}</Item>;
      });
    } else {
      if (children instanceof Item) {
        return children;
      }

      return <Item key={`flex-item-0`}>{children}</Item>;
    }
  }, [children]);

  return <div className={cx(direction, gap, variant)}>{childElements}</div>;
};
